import { SxProps } from "@mui/material";
import theme from "Theme/AppTheme";
import { SelectedTargetFields, TargetFieldOptions } from "../types";

export const fieldContainerStyles: SxProps = {
    display: "flex",
    flexDirection: "column",
    gap: 2,
};

export const fieldStyles: SxProps = {
    display: "flex",
    gap: 1,
    background: theme.palette.white.main,
    borderRadius: 2,
    padding: theme.spacing(1),
    alignItems: "center",
};

export const checkBoxStyles: SxProps = {
    flex: 1,
    padding: theme.spacing(0.5),
    margin: theme.spacing(0),
    height: "fit-content",
};

export const arrowStyles: SxProps = {
    color: theme.palette.gray[400],
};

export const selectCustomStyle = (style) => ({
    container: () => ({
        border: `1px solid ${theme.palette.gray[200]}`,
        borderRadius: theme.shape.borderRadius,
        ...style,
    }),
});

export const getDefaultValue = ({
    id,
    selectedTargetFields,
    targetFieldOptions,
}: {
    id: string;
    selectedTargetFields: SelectedTargetFields;
    targetFieldOptions: TargetFieldOptions;
}) => {
    const selectedField = selectedTargetFields.find(
        (field) => field.sourceFieldId === id,
    );

    return targetFieldOptions.flattened.find(
        (field) => field.id === selectedField?.targetFieldId,
    );
};
